import template from '../../templates/Home/writer.template';
import Component from '../../core/component';

export default class Writer extends Component {
    constructor(data) {
        super(template, data);
    }
}
